import { ArrecadacaoForm } from "features/arrecadacoes/typings/form";
import {
  FormaDistribuicaoArrecadacaoEnum,
  TipoArrecadacaoEnum,
} from "features/arrecadacoes/enums";

export function getValoresManuaisCadaUnidade(form: ArrecadacaoForm) {
  const isDistribuicaoManual =
    form.formaDistribuicaoArrecadacaoId !==
      FormaDistribuicaoArrecadacaoEnum.UnicaUnidade &&
    form.tipoArrecadacaoId === TipoArrecadacaoEnum.ValorDiferenteCadaUnidade;

  const _valoresManuais =
    isDistribuicaoManual && form.valorManualUnidades
      ? Object.entries(form.valorManualUnidades).reduce((acc, [key, value]) => {
          if (Number(value) > 0) {
            acc[key] = value;
          }
          return acc;
        }, {} as Record<string, number>)
      : {};

  return _valoresManuais;
}
